export default __webpack_public_path__ + "static/productplaceholder-a064cc4cb136c23762ea145a3d2ef034.png";